function toInt(value, fallback = null) {
  const num = Number(value);
  if (Number.isNaN(num)) {
    return fallback;
  }
  return num;
}

function toBool(value, fallback = false) {
  if (value === null || value === undefined) {
    return fallback;
  }
  return Boolean(value);
}

export function getApplyPayStatus(exam) {
  if (
    !exam ||
    !exam.apply ||
    exam.apply.payStatus === null ||
    exam.apply.payStatus === undefined
  ) {
    return null;
  }
  return toInt(exam.apply.payStatus, null);
}

export function getEnrollCheckStatus(exam) {
  if (
    !exam ||
    !exam.enrollCheck ||
    exam.enrollCheck.status === null ||
    exam.enrollCheck.status === undefined
  ) {
    return null;
  }
  return toInt(exam.enrollCheck.status, null);
}

export function isPaid(exam) {
  return getApplyPayStatus(exam) === 1;
}

export function isApplyUnpaid(exam) {
  const payStatus = getApplyPayStatus(exam);
  return payStatus !== null && payStatus !== 1;
}

export function requiresEnrollCheckBeforePay(exam) {
  return (
    toBool(exam && exam.requireApplicationForm) ||
    toBool(exam && exam.requirePrimaryCerti) ||
    toBool(exam && exam.requirePiccWorkYear) ||
    toBool(exam && exam.requireMonthPiccNum)
  );
}

export function resolveEnrollOperationState(exam) {
  if (isPaid(exam)) {
    return "enrolled";
  }

  const checkStatus = getEnrollCheckStatus(exam);
  if (checkStatus === 0) {
    return "auditing";
  }
  if (checkStatus === 1) {
    return "wait_pay";
  }
  if (checkStatus === 2) {
    return "reapply";
  }
  if (isApplyUnpaid(exam)) {
    return "wait_pay";
  }
  if (requiresEnrollCheckBeforePay(exam)) {
    return "enroll_apply";
  }
  return "enroll_pay";
}
